import React from 'react';
import { RiArrowDropUpLine, RiArrowDropDownLine, RiCloseLine } from 'react-icons/ri';
import { Field } from 'formik';

export const DropdownWithCheckboxes = ({ field, options, form: { touched, errors } }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [searchTerm, setSearchTerm] = React.useState('');
    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleRemove = (value) => {
        const updatedValues = field?.value?.filter((item) => item !== value);
        field.onChange({ target: { name: field.name, value: updatedValues } });
      };
    let filteredOptions = options.sort((a, b) => {
      if (field?.value?.includes(a.vesselId) && !field?.value?.includes(b.vesselId)) {
        return -1;
      }
      if (!field?.value?.includes(a.vesselId) && field?.value?.includes(b.vesselId)) {
        return 1;
      }
      return 0;
    }).filter((option) => {
      return option?.label?.toLowerCase();
    });
     filteredOptions = options.filter((option) => option?.label.toLowerCase()
      .includes(searchTerm.toLowerCase())
      || option?.imoNumber?.toString().includes(searchTerm.toLowerCase())
      || option?.vesselCode?.toString().toLowerCase().includes(searchTerm.toLowerCase()));

      return (
      <div className="vessel-drop-down-root">
        <div
          className="dropdown-header vessel-drop-down-root-inner"
        >
          <input
            type="text"
            placeholder="Search by IMO, VesselName, Vessel Code"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onClick={() => setIsOpen(true)}
            className="no-outline-input"
          />
          <span
            className="vessel-drop-down-drop-down-indicator"
            onClick={toggleDropdown}
          >
            {isOpen ? <RiArrowDropUpLine /> : <RiArrowDropDownLine />}
          </span>
        </div>
        {touched[field.name] && errors[field.name] && <div className="error text-xs mt-1">{errors[field.name]}</div>}

        {isOpen && (
          <div
            className="dropdown-options dropdown-vessel-group"
          >
            {filteredOptions.map((option) => (
            <div>
             <label
             key={option.value}
             className="text-gray-100 p-1 block text-sm font-muli text-left input-label vessel-dropdown-outer-container"
             >
             <div className="vessel-drop-down-drop-down-option-checkbox-container">
               <Field
                 className="mr-0 rounded bg-gray-30 focus:ring-0 focus:outline-none"
                 type="checkbox"
                 name={field.name}
                 value={option.value}
                 id="vesselDropDownCheckBox"
                 onChange={(e) => {
                   const set = new Set(field.value);
                   if (e.target.checked) {
                     set.add(option.value);
                   } else {
                     set.delete(option.value);
                   }
                   field.onChange({ target: { name: field.name, value: Array.from(set) } });
                 }}
               />
               <span>{option.label}</span>
             </div>
             <div
              className="vessel-dropdown-inner-container"
             >
             <span className="truncate max-w-[150px] block overflow-hidden whitespace-nowrap">{option.imo ? `IMO-${option.imo}` : ''}</span>
             <span className="truncate max-w-[150px] block overflow-hidden whitespace-nowrap">{option.vesselCode ? `VC-${option.vesselCode}` : ''}</span>
             </div>
             </label>
            </div>
            ))}
          </div>
        )}
        { field?.value?.length > 0
        && (
        <div className="add-vessel-group-text-box">
          {field.value?.length > 0 && field?.value?.map((selected) => {
            const option = options.find((opt) => opt.value === selected);
            return (
              <span
                className=" text-gray-100 p-1 block font-muli text-left input-label add-vessel-group-text-box-chip"
                key={selected}
              >
                <p className="text-gray-100 opacity-60">
                {option?.label}
                <span>  [</span>
                {option?.imoNumber}
                <span>, VC</span>
                <span>
                {option?.vesselCode}
                </span>
                 <span>] </span>
                </p>
                <button
                  className="text-gray-100 opacity-70 add-vessel-group-text-box-chip-rm-btn"
                  type="button"
                  onClick={() => handleRemove(selected)}
                >
                  <RiCloseLine size="20px" />
                </button>
              </span>
            );
          })}
        </div>
      )}
      </div>
    );
};
